// extracted by mini-css-extract-plugin
export default {"chatWidget":"_1kxvw","mobile":"Zp13L","expanded":"_3v8YN","left":"_27KMz","minimizedChat":"_28JNc","right":"_2RCUa","fixed":"_1YW90"};